import { IApiData, IPerformanceGraphApi } from "../types/performance-graph-type.types";
import { API_PATHS } from "../constants/api-paths";
import { API_STATUS_CODE } from "../constants/util";
import { logErrorToNewRelic } from "../utils/logging";
import { request } from "../core/api.client";
export const getPerformanceGraph = async (data: IApiData) => {
  const response: IPerformanceGraphApi = await request({
    method: "POST",
    url: `${API_PATHS.getChartDataScript}`,
    data: { ...data },
  });

  if (response.statusCode !== API_STATUS_CODE.success) {
    logErrorToNewRelic(response.message);
    throw new Error(response.message);
  }
  return response;
};
